import React from "react";

type BadgeColor = "green" | "red" | "amber" | "blue" | "gray" | "secondary";

interface BadgeProps {
  children: React.ReactNode;
  color?: BadgeColor;
  dot?: boolean;
}

const COLOR_VAR: Record<Exclude<BadgeColor, "gray">, string> = {
  green: "var(--c-success)",
  red: "var(--c-danger)",
  amber: "var(--c-warning)",
  blue: "var(--c-info)",
  secondary: "var(--c-secondary)",
};

export function Badge({ children, color = "gray", dot }: BadgeProps) {
  const isGray = color === "gray";
  const cssVar = isGray ? undefined : COLOR_VAR[color];

  const style: React.CSSProperties = isGray
    ? {
        backgroundColor: "transparent",
        color: "var(--c-text-secondary)",
        borderColor: "var(--c-border-hover)",
      }
    : {
        backgroundColor: "transparent",
        color: cssVar,
        borderColor: "var(--c-border-hover)",
      };

  return (
    <span
      className="inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full text-[11px] font-medium border"
      style={style}
    >
      {dot && (
        <span
          className="w-1.5 h-1.5 rounded-full"
          style={{ backgroundColor: "currentColor" }}
        />
      )}
      {children}
    </span>
  );
}
